import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.some.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { __decorate } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import { asyncRoutes, constantRoutes } from '@/router';
import store from '@/store';
var hasPermission = function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(function (role) {
      return route.meta.roles.includes(role);
    });
  } else {
    return true;
  }
};
var _filterAsyncRoutes = function filterAsyncRoutes(routes, roles) {
  var res = [];
  routes.forEach(function (route) {
    var r = _objectSpread({}, route);
    if (hasPermission(roles, r)) {
      if (r.children) {
        r.children = _filterAsyncRoutes(r.children, roles);
      }
      res.push(r);
    }
  });
  return res;
};
export { _filterAsyncRoutes as filterAsyncRoutes };
var Permission = /*#__PURE__*/function (_VuexModule) {
  function Permission() {
    var _this;
    _classCallCheck(this, Permission);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Permission, [].concat(args));
    _defineProperty(_this, "routes", []);
    _defineProperty(_this, "dynamicRoutes", []);
    return _this;
  }
  _inherits(Permission, _VuexModule);
  return _createClass(Permission, [{
    key: "SET_ROUTES",
    value: function SET_ROUTES(routes) {
      this.routes = constantRoutes.concat(routes);
      this.dynamicRoutes = routes;
    }
  }, {
    key: "GenerateRoutes",
    value: function GenerateRoutes(roles) {
      var accessedRoutes = _filterAsyncRoutes(asyncRoutes, roles);
      this.SET_ROUTES(accessedRoutes);
    }
  }]);
}(VuexModule);
__decorate([Mutation], Permission.prototype, "SET_ROUTES", null);
__decorate([Action], Permission.prototype, "GenerateRoutes", null);
Permission = __decorate([Module({
  dynamic: true,
  store: store,
  name: 'permission'
})], Permission);
export var PermissionModule = getModule(Permission);